import TiltFocusPoints from "./TiltFocusPoints";
import {plotDicyStreak} from "./TileLayersUtils";
import {zProfileFolderPath} from "../../../utils/const";

class TiltFocusWithDicy extends TiltFocusPoints {
    id = "tiltFocusWithDicy";
    label = "Tilt";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    getDicy = (focusUnit) => {
        let {slide, deviceSettings, focusDicy, textColor, textSize, tileFlag} = this.props;
        let {loc_on_machine, tile_viewer_path, bucket_name, uperpixel, y_fields, tile_height} = slide;
        Object.values(focusDicy).forEach(val => {
            if (focusUnit['unifiedFocusId'] === parseInt(val['id'])) {
                let folderLink = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                    zProfileFolderPath + val["folder"] + "/" + val["subFolder"];
                let vectorSource = this.layer.getSource();
                plotDicyStreak(tileFlag, val, slide, vectorSource, deviceSettings, y_fields, tile_height,
                    uperpixel, textColor, textSize, folderLink);
            }
        });
    }

    render() {
        return null;
    }
}

export default TiltFocusWithDicy;